module.exports = __webpack_public_path__ + "static/assets/42a58c556c818c5b2a0c538d4167f03f.png";